/**
 * A minimal inline-SVG line chart for a short run of numeric samples (a
 * worker's recent CPU/memory/load history — see
 * pages/admin/AdminInfrastructureWorkers.jsx). No charting library: this is
 * the one shape this app needs, and the Sage Light system asks for no
 * gradients/decoration — just a single neutral line via `currentColor`, so
 * it already matches whatever text color its container sets.
 */
const Sparkline = ({ values, width = 120, height = 28, max: maxOverride, className = '' }) => {
  const clean = (values || []).filter((v) => typeof v === 'number' && !Number.isNaN(v));
  if (clean.length < 2) {
    return <span className={`text-xs text-muted-foreground ${className}`}>—</span>;
  }
  const max = maxOverride ?? Math.max(...clean, 1);
  const min = Math.min(...clean, 0);
  const range = max - min || 1;
  const stepX = width / (clean.length - 1);
  const points = clean
    .map((v, i) => `${(i * stepX).toFixed(1)},${(height - ((v - min) / range) * height).toFixed(1)}`)
    .join(' ');

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      role="img"
      aria-label="Recent history"
    >
      <polyline
        points={points}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Sparkline;
